import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '../data';

const Navbar = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const isActive = (path) => {
        return location.pathname === path ? 'navbar__link navbar__link--active' : 'navbar__link';
    };

    // Close menu when route changes
    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    // Prevent body scroll when menu is open
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMenuOpen]);

    return (
        <nav className="navbar">
            <div className="navbar__container">
                <Link to="/" className="navbar__logo">
                    <img src="/logo-phoenix-ai.png" alt="Phoenix AI logo" className="navbar__logo-icon" />
                    <span className="navbar__wordmark">Phoenix<span>AI</span></span>
                </Link>

                {/* Hamburger Button */}
                <button 
                    className={`navbar__hamburger ${isMenuOpen ? 'navbar__hamburger--active' : ''}`}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle menu"
                    aria-expanded={isMenuOpen}
                >
                    <span className="navbar__hamburger-line"></span>
                    <span className="navbar__hamburger-line"></span>
                    <span className="navbar__hamburger-line"></span>
                </button>

                {/* Navigation Links */}
                <div className={`navbar__links ${isMenuOpen ? 'navbar__links--open' : ''}`}>
                    {navLinks.map((link) => (
                        <Link key={link.path} to={link.path} className={isActive(link.path)}>
                            {link.label}
                        </Link>
                    ))}
                    <Link to="/contact" className="navbar__cta">
                        <button className="btn btn--primary">Contact Us</button>
                    </Link>
                </div>

                {/* Overlay */}
                {isMenuOpen && (
                    <div 
                        className="navbar__overlay" 
                        onClick={() => setIsMenuOpen(false)}
                    />
                )}
            </div>
        </nav>
    );
};

export default Navbar;
